var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { class: _vm.$style.container }, [
    _vm.logo
      ? _c("img", {
          class: _vm.$style.logoImage,
          attrs: { src: "/images/logos/" + _vm.logo },
        })
      : _c("div", { class: _vm.$style.noLogo }, [
          _c("div", {
            staticClass: "fa fa-image",
            class: _vm.$style.noLogoIcon,
            attrs: { "aria-hidden": "true" },
          }),
          _c("div", { class: _vm.$style.noLogoLabel }, [
            _vm._v(" Your logo goes here "),
          ]),
        ]),
    _vm.isAdmin
      ? _c(
          "button",
          {
            staticClass:
              "rbButton expandButtonToShowText accountProfileUploadImageButton",
            class: _vm.$style.uploadButton,
            on: { click: _vm.editLogo },
          },
          [
            _c("i", { staticClass: "material-icons" }, [_vm._v("add_a_photo")]),
            _vm._v(" "),
            _c("span", { class: _vm.$style.uploadButtonLabel }, [
              _vm._v("Upload"),
            ]),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }